/**
 * Function that checks if any of the interactions are firing
 * @param values => object with the values of the interactions [move:false,pan:false,etc]
 * @param actions => array with the actions that are being checked [move,pan,etc]
 */
export function checkInteractionsFiring(values, actions) {
  return Object.entries(values)
    .map(([key, val]) => (val && actions
      .includes(key)));
}

export default checkInteractionsFiring;
